/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ subject: NonNullable<unknown> }} Rights_Tools_Drawer_TitleInputs */



/**
* | output |
* | --- |
* | "Tool access for {subject}" |
*
* @param {Rights_Tools_Drawer_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_tools_drawer_title = /** @type {((inputs: Rights_Tools_Drawer_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Tools_Drawer_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Tool-Zugriff für ${i?.subject}`)
	return /** @type {LocalizedString} */ (`Tool access for ${i?.subject}`)
});